import { Consume } from "../../../Context/Consumer";
import React, { Component } from "react";
import {
  PlayerListContext,
  TransContext,
  TeamDataContext,
} from "../../../Context";
import {
  getTrans,
  makeClasses,
  customTracking,
  getPageName,
} from "../../../common";
import config from "../../../common/config";
import {Scrollbars} from "react-custom-scrollbars";
import OutsideNotifier from "../../OutsideNotifier";

class WebSkillFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openSkillFilter: false,
    };
    this.playerSkillsArray = config.skillsFilterWeb;
  }

  onSkillFilterOpen = (value) => {
    if (value != undefined) {
      this.setState({
        openSkillFilter: false,
      });
    } else {
      this.setState({
        openSkillFilter: !this.state.openSkillFilter,
      });
    }
  };

  onSkillsSelect = (obj) => {
    let skillId = obj.map;
    let budget = this.props.TeamData.data.budget;
    if (skillId == 0) {
      if (
        this.props.PlayerListData.playerListFilters.skillId.indexOf(skillId) >
        -1
      ) {
        this.props.PlayerListData.playerListFilters.skillId = [];
      } else {
        let skillName = config.positionMap[skillId]
          ? config.positionMap[skillId].skill
          : "All";
        this.props.PlayerListData.playerListFilters.skillId = [0];
      }
    } else {
      if (this.props.PlayerListData.playerListFilters.skillId.indexOf(0) > -1) {
        let index =
          this.props.PlayerListData.playerListFilters.skillId.indexOf(0);
        this.props.PlayerListData.playerListFilters.skillId.splice(index, 1);
      }
      if (
        this.props.PlayerListData.playerListFilters.skillId.indexOf(skillId) >
        -1
      ) {
        let index =
          this.props.PlayerListData.playerListFilters.skillId.indexOf(skillId);
        this.props.PlayerListData.playerListFilters.skillId.splice(index, 1);
      } else {
        let skillName = config.positionMap[skillId]
          ? config.positionMap[skillId].skill
          : "All";
        this.props.PlayerListData.playerListFilters.skillId.splice(0, 1);
        this.props.PlayerListData.playerListFilters.skillId.push(skillId);
      }
    }

    this.props.PlayerListData.setPlayerFilters(
      this.props.PlayerListData.playerListFilters,
      budget
    );
    this.onSkillFilterOpen(false);
  };

  render() {
    let self = this;
    let { state, props, onSkillFilterOpen, onSkillsSelect, playerSkillsArray } =
      self;
    let { openSkillFilter } = state;
    let { PlayerListData, TransData } = props;
    let trans = TransData.data;
    let handler = {
      handler: () => {
        onSkillFilterOpen(false);
      },
    };
    let { skillId } = PlayerListData.playerListFilters;
    return (
      <div className="si-filter__col">
        <OutsideNotifier {...handler}>
          <div className="si-form__control">
            <div className="si-lbl">
              <span>{getTrans(trans,"positions","Positions")}</span>
            </div>
            <div
              className={"si-drpDwn " + (openSkillFilter ? "si-active" : "")}
              onClick={() => onSkillFilterOpen()}
            >
              <div className="si-drpDwn__value si-picked">
                <span>
                  {skillId && skillId.length
                    ? getTrans(trans,config.skillsFilterWeb[skillId[0]]?.skillTrans)
                    : getTrans(trans,"All","All")}
                </span>
                <select
                  onChange={(e) => {
                    const skill = playerSkillsArray.filter(
                      (a) => a.skill === e.target.value
                    );
                    onSkillsSelect(...skill);
                  }}
                >
                  {playerSkillsArray.map((skills) => {
                    return (
                      <option
                        // onClick={() => {
                        //   onSkillsSelect(skills);
                        // }}
                        key={skills.map}
                        className={
                          PlayerListData.playerListFilters.skillId.indexOf(
                            skills.map
                          ) > -1
                            ? "si-active"
                            : ""
                        }
                      >
                        {getTrans(trans, skills.skillTrans, skills.skill)}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="si-drpDwn__list">
                  <Scrollbars className="si-scroll_js">
                <ul>
                    {playerSkillsArray.map((skills) => {
                      return (
                        <li
                          onClick={() => {
                            onSkillsSelect(skills);
                          }}
                          key={skills.map}
                          className={
                            PlayerListData.playerListFilters.skillId.indexOf(
                              skills.map
                            ) > -1
                              ? "si-active"
                              : ""
                          }
                        >
                          {getTrans(trans, skills.skillTrans, skills.skill)}
                        </li>
                      );
                    })}
                </ul>
                  </Scrollbars>
              </div>
            </div>
          </div>
        </OutsideNotifier>
      </div>
    );
  }
}

export default Consume(WebSkillFilter, [
  PlayerListContext,
  TransContext,
  TeamDataContext,
]);
